import "./App.css";
import "./AppKeyRow.css";

export default function AppKeyRow(props) {
    const onClick = () => {
        props.onClick(props.data.id);
    };

    const onDelete = () => {
        props.onDelete(props.data.id);
    };

    return (
        <div className="list-view-item">
            <strong>{ props.data.appName }</strong>
            <div className="list-view-item-content">
                <span>{ props.data.description }</span>
                <div>
                    <button className="clear-button" onClick={ onDelete }>
                        <img src="img/delete_outline_black_24dp.svg" />
                    </button>
                    <button className="clear-button" onClick={ onClick }>
                        <img src="img/launch_black_24dp.svg" />
                    </button>
                </div>
            </div>
        </div>
    );
}